'use client'
import classNames from 'classnames'
import React, { type FC } from 'react'
import styles from './StoreDeliveryFeeText.module.scss'
import { IconSize, LogoPrimeIcon, PersonRiderIcon } from '@/tools/ui'

interface Props {
  baseFee: string
  shouldShowPrimeFee: boolean | undefined
}

export const StoreDeliveryFeeText: FC<Props> = ({ baseFee, shouldShowPrimeFee }) => {
  const icon = shouldShowPrimeFee ? (
    <LogoPrimeIcon className={styles.logo} size={IconSize.small} />
  ) : (
    <PersonRiderIcon size={IconSize.small} />
  )

  return (
    <div className={styles.deliveryFee}>
      <div className={styles.baseFee}>
        {icon}
        <p
          className={classNames(
            { [styles.primeFee]: shouldShowPrimeFee },
            'pintxo-typography-caption'
          )}
        >
          {baseFee}
        </p>
      </div>
    </div>
  )
}
